// Generated from SVG to Code Figma Plugin

export const BaseLineCancelsubmission = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_2262_1706)">
      <path
        d="M11 6.74902L20.9072 2.65691C21.6169 2.36378 22.3785 2.94672 22.2809 3.70834L21.25 11.749L20.625 16.624M20.1563 20.2803V20.2803C20.0847 20.838 19.4494 21.1236 18.9848 20.8068L9.14229 14.096C9.04813 14.0318 8.94367 13.9842 8.83345 13.9552L2.37474 12.2555C1.44807 12.0117 1.36183 10.73 2.24747 10.3642L5.25 9.12402L6.6875 8.53027L7.40625 8.2334"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <path
        d="M9 13.999L11.4 11.9998M16 7.99902L14.25 9.49902"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <path
        d="M9 13.999V17.899C9 18.5717 9.85637 18.8572 10.26 18.319L12 15.999"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <path d="M3 3L21 21" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
    </g>
    <defs>
      <clipPath id="clip0_2262_1706">
        <rect height="24" width="24" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
